/*
 * old-price-format.js
 * The storefront reformats the *current* price client-side (market/currency app),
 * e.g. shop format "11,90€" becomes "€11.90". Our struck old price is server-rendered
 * in the shop money format, so it can mismatch. This reformats every `.abc-orig-price`
 * to match the *displayed* current price next to it (same approach as the AB test's
 * formatLikeTemplate). Same-currency reformatting only (separators / symbol position).
 * Guarded by window.OLD_PRICE_LABEL_ENABLED.
 */
(function () {
  if (window.OLD_PRICE_LABEL_ENABLED !== true) return;

  function parseMoney(str) {
    if (str == null) return NaN;
    var t = String(str).replace(/[^\d.,]/g, '');
    if (!t) return NaN;
    var dec = t.match(/([.,])(\d{1,2})$/);
    var norm;
    if (dec) {
      var sep = dec[1];
      var thou = sep === ',' ? '.' : ',';
      norm = t.split(thou).join('').replace(sep, '.');
    } else {
      norm = t.replace(/[.,]/g, '');
    }
    return parseFloat(norm);
  }

  function formatLikeTemplate(template, amount) {
    var n = Number(amount);
    if (template == null || !isFinite(n)) return template;
    var t = String(template);
    var numMatch = t.match(/[\d.,]+/);
    if (!numMatch) return t;
    var numToken = numMatch[0];
    var decMatch = numToken.match(/([.,])(\d{1,2})$/);
    var decSep = decMatch ? decMatch[1] : '.';
    var thouSep = decSep === ',' ? '.' : ',';
    var abs = Math.abs(n);
    var intPart = Math.floor(abs).toString().replace(/\B(?=(\d{3})+(?!\d))/g, thouSep);
    var frac = Math.round((abs - Math.floor(abs)) * 100).toString().padStart(2, '0');
    var newNum = (n < 0 ? '-' : '') + intPart + decSep + frac;
    return t.replace(numToken, newNum);
  }

  // The current (displayed) price element nearest to this struck old price.
  function currentPriceText(oldEl) {
    var box = oldEl.closest('.product-price-group, .product-grid--price, .product-card-basic__price, .main-price') || oldEl.parentElement;
    if (!box) return null;
    var els = box.querySelectorAll('[data-price-text], .abc-price--new, .price--regular-price, .price--sale-price, .igPrice');
    for (var i = 0; i < els.length; i++) {
      if (!els[i].classList.contains('abc-orig-price')) {
        var txt = els[i].textContent.trim();
        if (txt) return txt;
      }
    }
    return null;
  }

  function sync() {
    var list = document.querySelectorAll('.abc-orig-price');
    for (var i = 0; i < list.length; i++) {
      var oldEl = list[i];
      var tmpl = currentPriceText(oldEl);
      if (!tmpl) continue;
      var amt = parseMoney(oldEl.textContent);
      if (!isFinite(amt)) continue;
      var formatted = formatLikeTemplate(tmpl, amt);
      if (formatted && oldEl.textContent.trim() !== formatted) oldEl.textContent = formatted;
    }
  }

  var observer = null;
  function syncSafe() {
    if (observer) observer.disconnect();
    try { sync(); } finally {
      if (observer) observer.observe(document.body, { childList: true, subtree: true });
    }
  }

  var pending = null;
  function schedule() {
    if (pending) return;
    pending = setTimeout(function () { pending = null; syncSafe(); }, 250);
  }

  function init() {
    syncSafe();
    // Catch the currency/market app reformatting the current price after our first pass.
    [300, 800, 1500].forEach(function (ms) { setTimeout(syncSafe, ms); });

    observer = new MutationObserver(schedule);
    observer.observe(document.body, { childList: true, subtree: true });

    if (window.eventBus && typeof window.eventBus.on === 'function') {
      window.eventBus.on('variant:updated', function () { setTimeout(syncSafe, 0); setTimeout(syncSafe, 300); });
    }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
